import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { TRUST_POINTS } from "./data";

export const TrustBar = () => {
  return (
    <section className="bg-[#F9FAFB] border-b border-gray-200" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {TRUST_POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex items-start gap-3 py-8 lg:px-6 md:border-r border-gray-200 last:border-r-0"
              data-testid={`trust-point-${i}`}
            >
              <CheckCircle2 className="text-[#FE6A04] shrink-0 mt-0.5" size={22} />
              <div>
                <h3 className="font-heading font-semibold text-[#001E52] text-[15px]">{p.title}</h3>
                <p className="text-sm text-gray-500 mt-1 leading-relaxed">{p.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
